import { render, staticRenderFns } from "./BasicRecordFieldItem.vue?vue&type=template&id=09c43989&"
import script from "./BasicRecordFieldItem.vue?vue&type=script&lang=js&"
export * from "./BasicRecordFieldItem.vue?vue&type=script&lang=js&"
import style0 from "./BasicRecordFieldItem.vue?vue&type=style&index=0&id=09c43989&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports